import { render } from "./RankingItems.vue?vue&type=template&id=29df5ef6&scoped=true"
import script from "./RankingItems.vue?vue&type=script&lang=js"
export * from "./RankingItems.vue?vue&type=script&lang=js"

import "./RankingItems.vue?vue&type=style&index=0&id=29df5ef6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29df5ef6"]])

export default __exports__